import api from "@/app/lib/api";
import { useDialog } from "@/utils/DialogProvider";
import { POST_REQUEST } from "@/utils/fetch";
import { availableName } from "@/utils/fncts";
import { Question } from "@/utils/types";
import { Chip } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

export const ChatBot = ({
  quest,
  setReponse,
  setQuestion,
}: {
  quest: any[];
  setReponse: Function;
  setQuestion: Function;
}) => {
  const { t, i18n } = useTranslation();
  const currentLocale = i18n.language as "ar" | "fr" | "en";

  const [selectedQuestions, setselectedQuestions] = useState<Question[]>([]);

  const {
    data: questionsAndResponses,
    isSuccess,
  } = useQuery({
    queryKey: ["chatbotQuestions"],
    queryFn: async () => {
      const res = await api.chatBotQuestions.getAll();
      if(selectedQuestions.length == 0) 
      setselectedQuestions([res[0], res[1] , res[2]]);
      return res;
    },
  });

  return (
    <div>
      <div
        className="flex gap10"
        style={{ maxWidth: "90vw", overflowX: "auto" }}
      >
        {isSuccess &&
          Array.isArray(selectedQuestions) &&
          selectedQuestions?.map((qust, index) => (
            <div key={index} className="">
              <Chip
                color="primary"
                label={availableName(qust?.question, currentLocale)}
                variant={"outlined"}
                onClick={async () => {
                  setQuestion({
                    question: availableName(qust?.question, currentLocale),
                    send_notif: qust?.send_notif == 1 ? true : false,
                  });
                  setReponse(availableName(qust?.response, currentLocale));

                  setselectedQuestions(
                    questionsAndResponses.filter((q: Question) =>
                      (qust?.next_questions as number[]).includes(q?.id)
                    )
                  );
                }}
              />
            </div>
          ))}
      </div>
    </div>
  );
};
